import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useNavigate, useParams} from "react-router-dom";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';

export default function ProposalConfirm(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let proposalId = decode.proposalId;

    let member = prop.member;
    let [detail, setDetail] = React.useState(null);
    let [btnDisabled, setBtnDisabled] = React.useState(false);
    let [statusList, setStatusList] = React.useState(null);

    //Applicant
    let refPrefix = React.useRef();
    let refFirstname = React.useRef();
    let refLastname = React.useRef();
    let refTitle = React.useRef();
    let refTitle_en = React.useRef();
    let refStatusDetail = React.useRef();

    React.useEffect(() => {
        window.scrollTo(0, 0);

        (async function() {
            try {
                const resDetail = await getDetail();
                setDetail(resDetail);

                const resultStatus = await Utils.getProposalStatus();
                setStatusList(resultStatus);

                if(resDetail) {
                    refPrefix.current.value = resDetail.applicant.prefix;
                    refFirstname.current.value = resDetail.applicant.firstname;
                    refLastname.current.value = resDetail.applicant.lastname;
                    refTitle.current.value = resDetail.title;
                    refTitle_en.current.value = resDetail.title_en;
                }

                document.title = 'ทุนวิจัย Scholarship | NCSA - ' + resDetail.title;
            } catch (e) {
                //
            }
        })();
    }, []);

    async function getDetail() {
        const response = await fetch(Config.apiUrl +'/proposal/viewProposal', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: proposalId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onCancel = () => {
        navigate((prop.lang === 'en' ? '/en':'') + '/proposal');
    };

    const onSubmit = async () => {
        let status_detail = refStatusDetail.current.value;

        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ยืนยันการส่งข้อเสนอโครงการนี้ ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        setBtnDisabled(true);

                        let fullname = detail.applicant.prefix + ' ' + detail.applicant.firstname + ' ' + detail.applicant.lastname;
                        let status = detail.status === Utils.PROPOSAL_STATUS_EDIT ? Utils.PROPOSAL_STATUS_UPDATE : Utils.PROPOSAL_STATUS_OFFER;
                        let status_name = statusList.filter(e => e.id === status)[0].title;
                        let datetime = moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');

                        let param = {
                            proposalId: detail.id,
                            status: status,
                            detail: status_detail,
                            createdBy: -1,
                            createdAt: datetime
                        };
                        const result = await sendProposal(param);
                        if(result) {
                            setBtnDisabled(false);
                            toast.success(prop.lang === 'en' ? 'Send Offer successfully.':'แจ้งส่งข้อเสนอโครงการ เรียบร้อย');
                            setTimeout(function () {
                            toast(prop.lang === 'en' ? 'Sending email, please wait..':'กำลังส่งอีเมล กรุณารอสักครู่..');
                            }, 1000);
                            if(result.status === 'success') {
                                setBtnDisabled(true);
                                const sendMember = await sendEmail({
                                    email: detail.applicant.email,
                                    proposal_name: detail.title,
                                    proposal_code: detail.code,
                                    scholarship_name: detail.scholarship.title,
                                    send_date: datetime,
                                    status_name: status_name,
                                    status_detail: status_detail,
                                    sender_name: fullname
                                });
                                const sendAdmin = await sendEmailAdmin({
                                    emails: result.email_admin,
                                    proposal_name: detail.title,
                                    proposal_code: detail.code,
                                    scholarship_name: detail.scholarship.title,
                                    send_date: datetime,
                                    status_name: status_name,
                                    status_detail: status_detail,
                                    sender_name: fullname
                                });

                                if(sendMember.status === 1 && sendAdmin.status === 1) {
                                    setBtnDisabled(false);
                                    toast.success(prop.lang === 'en' ? 'Send Offer successfully.': (detail.status === Utils.PROPOSAL_STATUS_EDIT ? 'ส่งอีเมลแจ้งแก้ไขข้อเสนอโครงการ เรียบร้อย':'ส่งอีเมลแจ้งส่งข้อเสนอโครงการ เรียบร้อย'));
                                    setTimeout(function () {
                                        window.location = (prop.lang === 'en' ? '/en':'/') + 'proposal';
                                    }, 1500);
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, Unable to send email at this time':'ขออภัย ไม่สามารถส่งอีเมลได้ในขณะนี้');
                                    setTimeout(function () {
                                        window.location = (prop.lang === 'en' ? '/en':'/') + 'proposal';
                                    }, 1500);
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                        else {
                            toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    async function sendProposal(param) {
        const response = await fetch(Config.apiUrl +'/proposal/sendProposalM', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmailAdmin(param) {
        const response = await fetch(Config.phpUrl +'/email_proposal_admin.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function sendEmail(param) {
        const response = await fetch(Config.phpUrl +'/email_proposal_member.php', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="proposal" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="card-body p-0 px-xxl-3">
                                <h2 className="h3 text-center">{prop.lang === 'en' ? 'Full Proposal':'ยื่นแบบฟอร์มข้อเสนอโครงการฉบับสมบูรณ์ (Full Proposal)'}</h2>
                                <div className="text-center">{prop.lang === 'en' ? 'Strategic Research Project (Strategic Fund; SF): Research Project Type':'โครงการวิจัยเชิงกลยุทธ์ (Strategic Fund; SF) : ประเภทโครงการวิจัย'}</div>
                                <h3 className="mt-2 text-center">{prop.lang === 'en' ? 'Research Fund Name ':'ชื่อทุนวิจัย '} : {prop.lang === 'en' ? detail?.scholarship.title_en : detail?.scholarship.title}</h3>

                                <h4 className="title-line-left mb-2">{prop.lang === 'en' ? 'Scholarship Applicants':'ข้อมูลผู้ขอรับทุน'}</h4>
                                <div className="row g-3 mt-2">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Prefix (Thai)':'คำนำหน้า (ภาษาไทย)'}</h6>
                                            <input type="text" className="form-control" ref={refPrefix} maxLength={250} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'First Name (Thai)':'ชื่อจริง (ภาษาไทย)'}</h6>
                                            <input type="text" className="form-control" ref={refFirstname} maxLength={250} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Last Name (Thai)':'นามสกุล (ภาษาไทย)'}</h6>
                                            <input type="text" className="form-control" ref={refLastname} maxLength={250} disabled={true} />
                                        </div>
                                    </div>
                                </div>
                                <h4 className="title-line-left mb-2">{prop.lang === 'en' ? 'Project name/research plan':'ชื่อโครงการ/แผนงานวิจัย'}</h4>
                                <div className="row g-3 mt-2">
                                    <div className="col-12">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Thai':'ภาษาไทย'}</h6>
                                            <input type="text" className="form-control" ref={refTitle} maxLength={250} disabled={true} />
                                        </div>
                                    </div>
                                    <div className="col-12 mt-3">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'English':'ภาษาอังกฤษ'}</h6>
                                            <input type="text" className="form-control" ref={refTitle_en} maxLength={250} disabled={true} />
                                        </div>
                                    </div>

                                    <div className="col-12 mt-3">
                                        <div className="form-group">
                                            <h6>{prop.lang === 'en' ? 'Comment':'ความคิดเห็น/ข้อเสนอแนะ'}</h6>
                                            <input type="text" className="form-control" ref={refStatusDetail} maxLength={250} />
                                        </div>
                                    </div>
                                </div>

                                <div className="py-3"><hr /></div>
                                <div className="buttons gap-15 py-0 mb-4">
                                    <button className="btn btn-gray w-130" type="button" onClick={onCancel}>{prop.lang === 'en' ? 'Prev':'ย้อนกลับ'}</button>
                                    <button className="btn btn-secondary" type="button" onClick={onSubmit} disabled={btnDisabled}>{prop.lang === 'en' ? 'Confirm to submit': ( detail?.status === Utils.PROPOSAL_STATUS_EDIT ? 'ยืนยันส่งแก้ไข':'ยืนยันส่งพิจารณา')}</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 